<template ref="mark">
  <div id="title">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name:'Title',
  mounted() {
    this.$nextTick(function(){
      document.title =  this.$el.innerHTML
    })
  }
}

</script>

<style scoped>
   #title {
    background:rgb(239,239,239);
    text-align: left;
    color: rgb(33,47,68);
    font-size: 20px;
    padding: 40px 0 22px;
   }
</style>


// WEBPACK FOOTER //
// src/plugins/Title.vue